<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="姓名">
        <el-input v-model="query.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      
      <el-form-item label="性别">
        <el-select v-model="query.gender" placeholder="请选择性别" clearable style="width: 150px">
          <el-option label="男" value="M"></el-option>
          <el-option label="女" value="F"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="手机号码">
        <el-input v-model="query.phone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      
      <el-form-item label="最高学历">
        <el-input v-model="query.highest_education" placeholder="请输入最高学历"></el-input>
      </el-form-item>
      
      <el-form-item label="期望职位">
        <el-input v-model="query.expected_position" placeholder="请输入期望职位"></el-input>
      </el-form-item>
      
      <el-form-item label="求职状态">
        <el-select v-model="query.job_status" placeholder="请选择求职状态" clearable style="width: 150px">
          <el-option label="在职-暂不考虑" value="employed_no_change"></el-option>
          <el-option label="在职-考虑机会" value="employed_considering"></el-option>
          <el-option label="离职-随时到岗" value="unemployed_available"></el-option>
          <el-option label="其他" value="other"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #gender="{ row }">
        <span>{{ row.gender === 'M' ? '男' : row.gender === 'F' ? '女' : '-' }}</span>
        <div>{{ calculateYearsFromNow(row.birth_date) }}岁</div>
      </template>
      
      <template #job_year="{ row }">
        <span>{{ calculateYearsFromNow(row.job_year) }}年</span>
      </template>

      <template #location="{ row }">
        <div>{{ [row.province, row.city, row.district].filter(Boolean).join('-') || '-' }}</div>
      </template>
      
     
      <template #handle="{ row }">
        <el-button type="primary" size="small" @click="viewDetails(row)">查看详情</el-button>
      </template>
    </auto-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: { firstNav: "人才管理", secondNav: "人才列表" },
      query: {
        name: '',
        gender: '',
        phone: '',
        highest_education: '',
        expected_position: '',
        job_status: ''
      },
      DataList: [],
      Option: [
        { name: "姓名", value: "name" },
        { name: "性别", value: "gender", type: "custom" },
        { name: "类目", value: "categories"},
        { name: "手机号码", value: "phone" },
        { name: "工作年限", value: "job_year",type: "custom" },
        { name: "最高学历", value: "highest_education" },
        { name: "期望职位", value: "expected_position" },
        { name: "期望薪资", value: "expected_salary" },
        { name: "期望工作地点", value: "expected_location" },
        { name: "求职状态", value: "job_status" },
        { name: "所在地区", value: "location", type: "custom" },
        { name: "操作", value: "handle", type: "custom" },
      ],
      Total: 0,
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    // 格式化日期
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 计算从指定日期到现在有多少年
    calculateYearsFromNow(date) {
      if (!date) return '-';
      const startDate = new Date(date);
      const now = new Date();
      
      let years = now.getFullYear() - startDate.getFullYear();
      const monthDiff = now.getMonth() - startDate.getMonth();
      
      // 如果月份差为负，或者月份相同但日期较小，则减1年
      if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < startDate.getDate())) {
        years--;
      }
      
      return years;
    },
    

    
    // 搜索
    search() {
      this.getList(1);
    },
    
    // 重置搜索条件
    resetSearch() {
      this.query = {
        name: '',
        gender: '',
        phone: '',
        highest_education: '',
        expected_position: '',
        job_status: ''
      };
      this.getList(1);
    },
    
    // 查看详情
    viewDetails(row) {
      this.$router.push({
        name: "talentDetails",
        query: { id: row.id }
      });
    },
    
    // 获取列表数据
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        ...this.query
      };
      
      // 过滤空值参数
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      
      this.$axios({
        url: "/user/talent/queryManagerListPage",
        params: params,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  background-color: #fff;
}

.demo-form-inline {
  margin-bottom: 20px;
}
</style>
